import { useState } from "react";
import {
  MdAssessment,
  MdBook,
  MdDesktopWindows,
  MdDownload,
  MdSave,
  MdSchool,
  MdSecurity,
  MdStorage,
  MdVisibility,
  MdVpnKey,
} from "react-icons/md";
import { PageContent, PageHeader, PageShell } from "../../components/layout/PageShell";
import { Textarea } from "../../components/ui";
import { COLORS, RADIUS, SPACING } from "../../shared/theme";

export default function PagePSSI({ pssi, setPssi }) {
  const [form, setForm] = useState(pssi);
  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }));

  const sections = [
    { key: "charteUtilisateurs", label: "1. Charte utilisateurs & Mots de passe", icon: <MdSecurity size={20} /> },
    { key: "gestionAcces", label: "2. Gestion des accès & Habilitations", icon: <MdVpnKey size={20} /> },
    { key: "classificationDonnees", label: "3. Classification des données", icon: <MdAssessment size={20} /> },
    { key: "sauvegardes", label: "4. Sauvegardes & Archivage", icon: <MdStorage size={20} /> },
    { key: "gestionIncidents", label: "5. Gestion des incidents de sécurité", icon: <MdSecurity size={20} /> },
    { key: "formationSensibilisation", label: "6. Formation & Sensibilisation", icon: <MdSchool size={20} /> },
    { key: "supervision", label: "7. Supervision & Logs", icon: <MdVisibility size={20} /> },
    { key: "gestionPostes", label: "8. Sécurité des postes de travail", icon: <MdDesktopWindows size={20} /> },
    { key: "politique", label: "9. Gouvernance de la politique", icon: <MdBook size={20} /> },
  ];

  const save = () => {
    setPssi(form);
  };

  const exportPdf = () => {
    const body = sections.map(s => `<h3 style="margin:0 0 8px;font-size:14px;color:#374151">${s.label}</h3><p style="margin:0 0 16px;font-size:12px;line-height:1.6;color:#4b5563;white-space:pre-wrap">${(form[s.key] || "").replace(/</g, "&lt;").replace(/>/g, "&gt;") || "(Non renseigné)"}</p>`).join("");
    const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>PSSI - Politique de Sécurité</title></head><body style="font-family:system-ui,sans-serif;max-width:800px;margin:40px auto;padding:24px;color:#111">
<h1 style="margin:0 0 8px;font-size:22px;color:#7c2d12">PSSI — Politique de Sécurité des Systèmes d'Information</h1>
<p style="margin:0 0 32px;font-size:13px;color:#9a3412">Document cadre définissant les règles de sécurité applicables à tous</p>
${body}
</body></html>`;
    const win = window.open("", "_blank");
    if (win) {
      win.document.write(html);
      win.document.close();
      win.focus();
      setTimeout(() => {
        win.print();
        win.onafterprint = () => win.close();
      }, 250);
    }
  };

  return (
    <PageShell>
      <PageHeader
        title="PSSI — Politique de Sécurité des Systèmes d'Information"
        subtitle="Document cadre définissant les règles de sécurité applicables à tous"
      />

      <PageContent>
        <div style={{ background: COLORS.white, borderRadius: RADIUS.xl, border: `1.5px solid ${COLORS.border}`, padding: SPACING.xl, marginBottom: 20, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
          <div style={{ fontWeight: 800, fontSize: 14, color: COLORS.textPrimary, marginBottom: 16 }}>Sections de la PSSI</div>

          {sections.map(s => (
            <div key={s.key} style={{ marginBottom: 20 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
                <span style={{ display: "inline-flex", alignItems: "center", lineHeight: 1 }}>{s.icon}</span>
                <div style={{ fontSize: 13, fontWeight: 700, color: "#374151" }}>{s.label}</div>
              </div>
              <Textarea value={form[s.key]} onChange={set(s.key)} rows={3} placeholder={`Décrivez les règles et procédures pour ${s.label.toLowerCase()}...`} />
            </div>
          ))}

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 24, paddingTop: 20, borderTop: `1px solid ${COLORS.border}` }}>
            <button onClick={save} style={{ padding: "9px 18px", borderRadius: RADIUS.md, border: "none", background: "#0ea5e9", color: COLORS.white, fontSize: 13, fontWeight: 700, cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 6 }}><MdSave size={16} /> Enregistrer la PSSI</button>
            <button onClick={exportPdf} style={{ padding: "9px 18px", borderRadius: RADIUS.md, border: "1.5px solid #93c5fd", background: "transparent", color: "#93c5fd", fontSize: 13, fontWeight: 700, cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 6 }}><MdDownload size={16} /> Exporter PDF</button>
          </div>
        </div>
      </PageContent>
    </PageShell>
  );
}
